export const GET_HOME_PAGE_SERVICES = "GET_HOME_PAGE_SERVICES"
export const CREATE_HOME_PAGE_SERVICES = "CREATE_HOME_PAGE_SERVICES"
export const UPDATE_HOME_PAGE_SERVICES = "UPDATE_HOME_PAGE_SERVICES"
export const DELETE_HOME_PAGE_SERVICES = "DELETE_HOME_PAGE_SERVICES"

export const UPDATE_LIST_HOME_PAGE_SERVICE = "UPDATE_LIST_HOME_PAGE_SERVICE"
export const LOADING_HOME_PAGE_SERVICE = "LOADING_HOME_PAGE_SERVICE"
